import React from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
    Button
} from "@material-ui/core/";
import IntlMessages from "util/IntlMessages";

const ConfirmDialog = (props) => {

    return (
        <Dialog
            className="custom-popup confirm-popup"
            PaperProps={{ classes: { root: 'custom-popup-root' } }}
            open={true}
            onClose={props.onCancel}
            disableBackdropClick={true}
        >
            <div className="popup-wrap">
                <div className="popup-header">
                    <DialogTitle className="popup-title"><IntlMessages id="logout.alert"></IntlMessages></DialogTitle>
                </div>
                <DialogContent className="popup-content">
                    <div><IntlMessages id="popup.discardMsg"></IntlMessages></div>
                </DialogContent>
                <DialogActions className="popup-footer">
                    <Button 
                        onClick={props.onCancel}
                        className="secondary-button"
                        disableRipple={false}
                        disableFocusRipple={false}
                    >
                        <IntlMessages id="main.cancel"></IntlMessages>
                    </Button>
                    <Button 
                        onClick={props.onConfirm}
                        className="primary-button"
                        disableRipple={false}
                        disableFocusRipple={false}
                    >
                        <IntlMessages id="popup.discardChanges"></IntlMessages>
                    </Button>
                </DialogActions>
            </div>
        </Dialog>
    )
}

export default ConfirmDialog;